import { render, staticRenderFns } from "./PositionView.vue?vue&type=template&id=3db6f652&scoped=true&lang=pug"
import script from "./PositionView.vue?vue&type=script&lang=js"
export * from "./PositionView.vue?vue&type=script&lang=js"
import style0 from "./PositionView.vue?vue&type=style&index=0&id=3db6f652&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6f652",
  null
  
)

export default component.exports